import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { breakpoints } from '@sainsburys-tech/boltui-utils';

var useMedia = function useMedia(values, defaultValue) {
  var queries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setMatch = _useState2[1];

  var match = function match() {
    var definedQueries = queries || Object.keys(breakpoints).map(function (key) {
      return breakpoints[key];
    }).reverse();
    var matchingQuery = definedQueries.findIndex(function (item) {
      return window.matchMedia(item).matches;
    });
    return values[matchingQuery] || defaultValue;
  };

  useEffect(function () {
    var handler = function handler() {
      return setMatch(match);
    };

    window.addEventListener('resize', handler);
    handler();
    setMatch(match);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, []);
  return value;
};

export default useMedia;